import { render, staticRenderFns } from "./myCollect.vue?vue&type=template&id=14771b08&scoped=true&"
import script from "./myCollect.vue?vue&type=script&lang=js&"
export * from "./myCollect.vue?vue&type=script&lang=js&"
import style0 from "./myCollect.vue?vue&type=style&index=0&id=14771b08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14771b08",
  null
  
)

export default component.exports